// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Tv","widget":"e_Uv","title":"e_Vv","msrp":"e_Wv","separator":"e_Xv","textBadge":"e_Yv"};